<template>
<div class="o-deficiencies">
    <div class="o-deficiencies__header">
        <router-link
            :to="{ name: 'deficienciesList' }"
            class="o-deficiencies__title"
        >
            <a-icon class="o-deficiencies__icon" icon="Agrofags" />
            Niedobory
        </router-link>
        <h3 v-if="deficiecies" class="o-deficiencies__category">
            <!-- {{group}} -->
           <template v-if="group">{{ group.name }}  -</template> {{ deficiecies.element_name }}
        </h3>
    </div>
    <router-view></router-view>
</div>
</template>
<script>
export default {
    data() {
        return {}
    },
    computed: {
        group() {
            return this.$store.getters['deficiencies/group']
        },
        deficiecies() {
            return this.$store.getters['deficiencies/activeItem']
        }
    }
}
</script>